import React from 'react';
import styled from 'styled-components';
import {
  colors,
  fonts,
  breakpoints,
  radii,
  headingStyle,
  sectionPaddingStyle,
  containerStyle,
  icones,
} from '../annuaire/designSystem';

const Section = styled.section`
  margin: 0;
  ${sectionPaddingStyle}
  background-color: ${colors.white};
`;

const Container = styled.div`
  ${containerStyle}
`;

const Heading = styled.h2`
  ${headingStyle}
  font-size: 1.5rem;
  margin-bottom: 24px;

  @media (min-width: ${breakpoints.mobile}) {
    font-size: 2.125rem;
  }
`;

const Emphasis = styled.span`
  color: ${colors.bleu};
`;

const Intro = styled.p`
  font-family: ${fonts.body};
  font-size: 1.05rem;
  line-height: 1.75;
  margin-bottom: 32px;
  color: ${colors.textSecondary};
`;

const StrengthsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 16px;
`;

const StrengthItem = styled.li`
  display: flex;
  gap: 12px;
  align-items: flex-start;
`;

const StrengthIcon = styled.div`
  width: 44px;
  height: 44px;
  background-color: ${colors.bleuPastel};
  border-radius: ${radii.small};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }
`;

const StrengthText = styled.div`
  flex: 1;
  padding-top: 4px;
`;

const StrengthTitle = styled.strong`
  display: block;
  margin-bottom: 4px;
  color: ${colors.textDark};
  font-family: ${fonts.body};
  font-weight: 600;
`;

// Rotating icons for each strength point (RoulezJeunesse branded)
const STRENGTH_ICON_SRCS = [
  icones.pouceOk,
  icones.checklist,
  icones.shop,
  icones.calendrier,
  icones.aide,
];

export default function ShopDescription({ shop }) {
  const details = shop.details || {};
  const seo = details.seo || {};
  const introText = seo.introduction_seo || '';
  // points_forts may be a string (newline-separated) or an array
  const rawPoints = seo.points_forts || [];
  const pointsForts = Array.isArray(rawPoints)
    ? rawPoints
    : typeof rawPoints === 'string'
    ? rawPoints
        .split('\n')
        .map((s) => s.trim())
        .filter(Boolean)
    : [];
  const shopName = shop.name || '';

  if (!introText && pointsForts.length === 0) return null;

  return (
    <Section>
      <Container>
        <Heading>
          D&eacute;couvrez <Emphasis>{shopName}</Emphasis>
        </Heading>

        {introText && <Intro>{introText}</Intro>}

        {pointsForts.length > 0 && (
          <StrengthsList>
            {pointsForts.map((point, i) => {
              const raw =
                typeof point === 'string' ? point : point.texte || point;
              // Strip leading bullet characters (•, -, *) since the picto icons replace them
              const text =
                typeof raw === 'string'
                  ? raw.replace(/^[\s•\-*·]+/, '').trim()
                  : raw;
              return (
                <StrengthItem key={i}>
                  <StrengthIcon>
                    <img
                      src={STRENGTH_ICON_SRCS[i % STRENGTH_ICON_SRCS.length]}
                      alt=""
                    />
                  </StrengthIcon>
                  <StrengthText>
                    <StrengthTitle>{text}</StrengthTitle>
                  </StrengthText>
                </StrengthItem>
              );
            })}
          </StrengthsList>
        )}
      </Container>
    </Section>
  );
}
